import React from "react";

const RefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Refund Policy</h1>
      <p>
        At <strong>Forever Speed Skating Academy</strong>, we are dedicated to providing a safe and supportive environment for all our skaters. Please carefully review our refund policy before enrolling in any of our programs.
      </p>

      <h2>1. No Refund Policy</h2>
      <p>
        All fees paid to Forever Speed Skating Academy are <strong>non-refundable</strong> under any circumstances. This includes but is not limited to:
      </p>
      <ul>
        <li>Student absence due to personal reasons (illness, vacation, exams, etc.).</li>
        <li>Cancellation of sessions due to weather, emergencies, or public holidays.</li>
        <li>Discontinuation or withdrawal from the course after admission.</li>
      </ul>

      <h2>2. Missed Sessions</h2>
      <p>
        We do not offer refunds, credits, or makeup classes for sessions missed by the student. However, in the case of unavoidable long-term absences, students may request batch rescheduling (subject to availability and discretion of the academy).
      </p>

      <h2>3. Compulsory Gear Policy</h2>
      <p>
        Skaters must attend sessions with full safety gear including helmet, guard set, and club bodysuit. Refunds will not be issued for non-attendance due to missing gear.
      </p>

      <h2>4. Session Cancellation</h2>
      <p>
        In the event that a session is canceled due to unforeseen circumstances, the academy will attempt to inform students in advance. Such cancellations do not qualify for a refund but may be rescheduled at the academy’s discretion.
      </p>

      <h2>5. Use of Fines</h2>
      <p>
        A late fee of ₹200 is applicable if fees are not paid by the 10th of the month. This amount will be used to support underprivileged children in accessing skating education.
      </p>

      <h2>6. Contact Us</h2>
      <p>
        For questions or clarification regarding this policy, feel free to contact us:
      </p>
      <ul>
        <li><strong>Email:</strong> fssacademy2020@gmail.com</li>
        <li><strong>Phone:</strong> +91 79775 63085</li>
      </ul>
    </div>
  );
};

export default RefundPolicy;
